// extracted by mini-css-extract-plugin
module.exports = {"root":"AccessPoints_root__EJFbU","edit_buttons":"AccessPoints_edit_buttons__3areV","toolbar_button":"AccessPoints_toolbar_button__1ekGq"};